import React, { useState } from "react";
import PropTypes from "prop-types";

import img from "../../assets/images/layouts/portfolio.png";

Portfolio.propTypes = {
  data: PropTypes.array,
};

function Portfolio(props) {
  const { data } = props;

  const [dataBlock] = useState({
    subheading: "Join now",
    heading: "Become a PlayerzPortal Player Now",
  });
  return (
    <section className="portfolio">
      <div className="shape"></div>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="block-text center">
              <h6 className="sub-heading">
                <span>{dataBlock.subheading}</span>
              </h6>
              <h3 className="heading pd">{dataBlock.heading}</h3>
            </div>
          </div>
          <div className="grid md:grid-cols-2 gap-5">
            <div className="col-xl-6 col-md-6">
              <div className="portfolio__left">
                {data.map((idx) => (
                  <div key={idx.id} className="portfolio-box">
                    <div className="step">Step {idx.id}</div>
                    <div className="icon">
                      <img src={idx.img} alt="Cyfonii" />
                    </div>
                    <div className="content">
                      <h5 className="title">{idx.title}</h5>
                      <p>{idx.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="col-xl-6 col-md-6">
              <div className="portfolio__right">
                <div
                  className="image"
                  data-aos="fade-left"
                  data-aos-duration="2000"
                >
                  <img
                    src="https://cyfoniireact-eb8gshhgc-themesflat.vercel.app/static/media/portfolio.5c35beca2c37f3ee7eb9.png"
                    alt="cyfonii"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Portfolio;
